import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 500,
  name: 'Internal Server Error',
  description:
    'The server encountered an unexpected condition that prevented it from fulfilling the request. This is a generic catch-all error — the server crashed, threw an unhandled exception, or hit an unexpected state.',
  causes: [
    'An unhandled exception in the application code — null pointer, division by zero, failed type cast, or any uncaught runtime error.',
    'A database connection failure, query error, or migration mismatch causing the ORM to crash.',
    'A misconfigured server — missing environment variables, invalid config files, or a failed deployment that left the server in a broken state.',
  ],
  fixes: [
    'Check the server logs immediately. The 500 response hides the real error — the stack trace in logs reveals the root cause.',
    'If the error started after a deployment, roll back to the previous version and investigate the diff for breaking changes.',
    'Test your database connection and check for missing migrations. A common cause is a schema mismatch between code and database.',
  ],
  monitoringTip:
    'A 500 error is the most critical signal that something is broken in production. Uptrack checks every 30 seconds and alerts you within a minute — often before any user reports the issue.',
}

export const Route = createFileRoute('/_site/http/500')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
